import { useContext, useEffect, useRef, useState } from 'react';
import { ICurrentUser } from '../typings/api';
import { StoreContext } from '../store/store';

/**
 *
 * @param value Returns the previous value and store the current for next time.
 */
export function usePrevious<T>(value: T): T {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref: any = useRef<T>();
  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

export const useIsMounted = () => {
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return mounted;
};

export const useUserProvider = () => {
  const {user} = useContext(StoreContext);

  let isAuthorized = false;
  let showAssociatedCompanyWarning = false;
  if (user && user.authenticated) {
    isAuthorized = true;
  }
  if (user && user.authenticated && !user.hasAssociatedCompany) {
    showAssociatedCompanyWarning = true;
  }
  return [isAuthorized, showAssociatedCompanyWarning]
};

export const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.pageYOffset);
    };

    window.addEventListener('scroll', updatePosition);

    updatePosition();

    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  return scrollPosition;
};

export const useIsTnw = (datasetId: string) => {
  const [isTnw, setIsTnw] = useState<boolean>(false);

  useEffect(() => {
    setIsTnw(datasetId.toLowerCase().includes('tnw'));
  },  [datasetId]);

  return isTnw;
};

export const useIsDwf = (datasetId: string) => {
  const [isDwf, setIsDwf] = useState<boolean>(false)

  useEffect(() => {
    setIsDwf(datasetId.toLowerCase().includes('dwf'));
  },  [datasetId]);

  return isDwf;
}
